export default __webpack_public_path__ + "images/dd5c6bf43ff3ba3e25d47dc83c7ade27-nonpartisan_small.webp";